<template>
  <div>
    <div class="margin-bot-20">
      <label for="customer_segment_ids">Customer Segments*</label>
      <select
        id="customer_segment_ids"
        v-model="customerSegmentIds"
        name="customer_segment_ids[]"
        class="form-control"
        required
        multiple
      >
        <option
          v-for="customerSegment in customerSegments"
          :key="`customer-segment-${customerSegment.id}`"
          :value="customerSegment.id"
        >
          {{ customerSegment.name }}
        </option>
      </select>
    </div>

    <fieldset
      v-for="customerSegmentId in customerSegmentIds"
      :key="`customer-segment-${customerSegmentId}-nms-tokens`"
      class="margin-bot-20"
    >
      <legend>{{ customerSegments[customerSegmentId].name }} NMS Tokens</legend>

      <div
        v-for="(tokenFields, index) in nmsTokenFields(customerSegmentId)"
        :key="`token-fields-${customerSegmentId}-${index}`"
      >
        <label class="control-label">{{ tokenFields.label }}</label>
        <input
          v-model="nmsTokens[customerSegmentId][tokenFields.fieldName]"
          class="form-control margin-bot-20"
          type="text"
          :name="`nms_tokens[${customerSegmentId}][${tokenFields.fieldName}]`"
          required
        />
      </div>
    </fieldset>
  </div>
</template>

<script>
/**
 * Each of the following are a configuration of a token. If you need to change
 * a token or add a new token, this is where you'd define them.
 */
const resellerToken = {
  label: "VAR Org Token",
  fieldName: "org",
};

const clickonceToken = {
  label: "Clickonce Token",
  fieldName: "clickonce",
};

const standaloneToken = {
  label: "Standalone Token",
  fieldName: "standalone",
};

const powermicMobileToken = {
  label: "PMM Token",
  fieldName: "powermic_mobile",
};

const anywhereMobileToken = {
  label: "Anywhere Mobile Token",
  fieldName: "anywhere_mobile",
};

/**
 * Here, we define which tokens go with which customer segment. To make it easier,
 * these are keyed off of slug, not ID.  They appear in the order they are.
 * The same tokens will have different names per customer segment in the submitted data
 */
const nmsTokenFieldsByCustomerSegmentSlug = {
  med: [resellerToken, clickonceToken, standaloneToken, powermicMobileToken],
  procom: [resellerToken, clickonceToken, standaloneToken, anywhereMobileToken],
};

export default {
  props: {
    /**
     * Comes in as an object keyed by customer_segments.id
     * Has values of id, name, slug
     */
    customerSegments: {
      type: Object,
      required: true,
    },

    /**
     * "user" refers to editing data, or data from the unsuccessful submission
     */
    userCustomerSegmentIds: {
      type: Array,
      required: true,
    },

    userNmsTokens: {
      type: [Object, Array], // its an array when its empty from laravel (arg)
      required: true,
    },
  },

  data() {
    return {
      customerSegmentIds: [],
      nmsTokens: [],
    };
  },

  created() {
    // bring in user data
    this.customerSegmentIds = this.userCustomerSegmentIds;

    // create a scaffolding for these nested objects, setting them along the way from user data
    const nmsTokenDefinition = {};
    Object.values(this.customerSegments).forEach((customerSegment) => {
      nmsTokenDefinition[customerSegment.id] =
        this.userNmsTokens[customerSegment.id] || {};
    });

    this.nmsTokens = nmsTokenDefinition;
  },

  methods: {
    nmsTokenFields(customerSegmentId) {
      return nmsTokenFieldsByCustomerSegmentSlug[
        this.customerSegments[customerSegmentId].slug
      ];
    },
  },
};
</script>
